module.exports = __webpack_public_path__ + "static/media/usasf-logo.37056e54.jpg";